import { SET_ALERT } from './actionTypes';

export function setAlert(alert) {
  return {
    type: SET_ALERT,
    payload: alert
  };
}

export function showAlert() {
  return dispatch => {
    dispatch(setAlert(true));
  };
}

export function disableAlert() {
  return dispatch => {
    dispatch(setAlert(false));
  };
}



// WEBPACK FOOTER //
// ./src/store/reducers/alert/actions.js